export const dashboardPanelVertexShader = /* glsl */ `
  varying vec2 vUv;

  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`

export const dashboardPanelFragmentShader = /* glsl */ `
  uniform sampler2D uTexture;
  uniform float uTime;
  uniform float uOpacity;
  uniform float uGlowIntensity;
  uniform vec3 uGlowColor;
  uniform float uBorderOpacity;

  varying vec2 vUv;

  void main() {
    vec4 texColor = texture2D(uTexture, vUv);

    // Soft edge glow
    float edgeX = min(vUv.x, 1.0 - vUv.x);
    float edgeY = min(vUv.y, 1.0 - vUv.y);
    float edgeDist = min(edgeX, edgeY);
    float edgeGlow = (1.0 - smoothstep(0.0, 0.04, edgeDist)) * uBorderOpacity;

    vec3 finalColor = texColor.rgb;
    finalColor += uGlowColor * edgeGlow * uGlowIntensity;

    float finalAlpha = texColor.a * uOpacity;
    finalAlpha = max(finalAlpha, edgeGlow * uGlowIntensity * 0.6);

    gl_FragColor = vec4(finalColor, finalAlpha);
  }
`
